var React = require('react');

function PersonIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2F3641","fillRule":"evenodd","d":"M12,12 C10.3431458,12 9,10.6568542 9,9 C9,7.34314575 10.3431458,6 12,6 C13.6568542,6 15,7.34314575 15,9 C15,10.6568542 13.6568542,12 12,12 Z M9.47126166,13.8420103 C11.1127377,13.2954374 12.8871673,13.2957224 14.5284677,13.8428226 L16.6324555,14.5441518 C17.4491398,14.8163799 18,15.5806576 18,16.4415184 L18,18 L6,18 L6,16.4398652 C6,15.5787679 6.55115795,14.814336 7.36815402,14.5422956 L9.47126166,13.8420103 Z"}));
}

PersonIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = PersonIcon;

PersonIcon.default = PersonIcon;
